import React from 'react';
import PropTypes from 'prop-types';
import { Page, Text, Document, StyleSheet, Font } from '@react-pdf/renderer';
import regularFont from '../../assets/fonts/Metropolis-Regular.ttf';
import boldFont from '../../assets/fonts/Metropolis-SemiBold.ttf';

const AdminRoutePlanCustomTypeDeliveriesPdf = ({ deliveries }) => {
  const BORDER_COLOR = '#000';
  const BORDER_STYLE = 'solid';

  Font.register({
    family: 'metropolis',
    fonts: [{ src: regularFont }, { src: boldFont, fontWeight: 600 }],
  });

  // disable hyphenation
  Font.registerHyphenationCallback((word) => [word]);

  const styles = StyleSheet.create({
    body: {
      padding: 5,
      fontSize: 12,
      fontFamily: 'metropolis',
    },
    title: {
      fontSize: 35,
      marginTop: 20,
      marginBottom: 5,
      textAlign: 'center',
    },
    subtitle: {
      fontSize: 20,
      marginBottom: 5,
    },
    h3: {
      fontSize: 16,
    },
    small: {
      fontSize: 10,
    },
    bold: {
      fontWeight: 700,
    },
    info: {
      marginBottom: 5,
    },
    table: {
      display: 'table',
      width: 'auto',
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
    },
    tableRow: {
      margin: 'auto',
      flexDirection: 'row',
    },
    tableColHeader: {
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      fontSize: 10,
    },
    tableCol: {
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableCol1: {
      width: '70%',
    },
    tableCol2: {
      width: '15%',
    },
    tableCol3: {
      width: '15%',
    },
    tableCellHeader: {
      margin: 5,
      fontWeight: 700,
    },
    tableCell: {
      margin: 5,
      paddingTop: 5,
    },
    footer: {
      fontSize: 14,
      position: 'absolute',
      bottom: 5,
      right: 5,
    },
  });

  return (
    <Document>
      {deliveries.map((delivery) => {
        const namePieces = delivery.delivery.name.split(' ');
        const withoutFirst = namePieces.slice(1);
        return (
          <Page size="A8" style={styles.body} orientation="landscape">
            <Text style={styles.title}>
              {namePieces[0]}
              {'\n'}
              {withoutFirst.join(' ')}
            </Text>
            <Text style={styles.footer}>{delivery.deliveryFrom}</Text>
          </Page>
        );
      })}
    </Document>
  );
};

AdminRoutePlanCustomTypeDeliveriesPdf.propTypes = {
  deliveries: PropTypes.array.isRequired,
};

AdminRoutePlanCustomTypeDeliveriesPdf.defaultProps = {};

export default AdminRoutePlanCustomTypeDeliveriesPdf;
